import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Clock, Wallet, ContactRound, Timer, CreditCard, FileText,
} from 'lucide-react';
import WorkflowItem from './WorkflowItem';
import WorkflowConnector from './WorkflowConnector';

/**
 * EMPLOYEES workflow panel: Enter Time → Payroll, with a compact row of
 * additional employee actions beneath. Deliberately smaller than the
 * Vendors and Customers panels.
 */
export default function EmployeeWorkflow() {
  const navigate = useNavigate();
  return (
    <section className="wf-panel">
      <header className="wf-header">
        <span className="wf-header-title">Employees</span>
      </header>
      <div className="wf-body">
        <div className="wf-flow">
          <WorkflowItem icon={Clock} label="Enter Time" desc="Track employee hours" path="/employees" />
          <WorkflowConnector />
          <WorkflowItem icon={Wallet} label="Payroll" desc="Run payroll runs" path="/payroll" emphasized />
        </div>
        <div className="wf-sub">
          <button type="button" className="wf-sub-item" onClick={() => navigate('/employees')}>
            <ContactRound /> Employee Center
          </button>
          <button type="button" className="wf-sub-item" onClick={() => navigate('/employees')}>
            <Timer /> Time Tracking
          </button>
          <button type="button" className="wf-sub-item" onClick={() => navigate('/payroll')}>
            <Wallet /> Payroll Processing
          </button>
          <button type="button" className="wf-sub-item" onClick={() => navigate('/expenses')}>
            <CreditCard /> Employee Expenses
          </button>
          <button type="button" className="wf-sub-item" onClick={() => navigate('/payslip')}>
            <FileText /> Payslips
          </button>
        </div>
      </div>
    </section>
  );
}
